import auth from 'b2b-common/services/auth'

import privateView from './index'

import homeView from './home'
import contactView from './contact'
import internView from './intern'
import busViews from './bus/router'
import accountView from './account'
import { packageViews, tourViews } from './package/router'
import { hotelViews, villasViews } from './hotel/router'
import bookingViews from './bookings/router'
import otherViews from './other/router'
import newTourViews from './tour/router'

// TODO: add routes for packages, tours and hotels (for Tudor to do)

export default {
  path: 'private',
  name: 'Private/Default',
  component: privateView,
  redirect: { name: 'Private/Home' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) next()
      else next({ name: 'Public/Default' })
    }, () => {
      next({ name: 'Public/Default' })
    })
  },
  children: [
    {
      path: 'home',
      name: 'Private/Home',
      component: homeView
    },
    packageViews,
    tourViews,
    newTourViews,
    hotelViews,
    villasViews,
    bookingViews,
    busViews,
    otherViews,
    {
      path: 'intern',
      name: 'Private/Intern',
      component: internView
    },
    {
      path: 'contact',
      name: 'Private/Contact',
      component: contactView
    },
    {
      path: 'cont',
      name: 'Private/Account',
      component: accountView
    },
    {
      path: 'logout',
      name: 'Private/Logout',
      beforeEnter: (to, from, next) => {
        auth.logout()
          .then(() => {
            // TODO: inform of succcesful logout
            next({ name: 'Public/Default' })
          })
          .catch(() => {
            // TODO: inform user about problem
            next({ name: 'Private/Default' })
          })
      }
    }
  ]
}
